import React, { useEffect, useState } from "react";
import { useDataContext } from "../contexts/AuthContext";
import { useNavigate } from "react-router-dom";

import { Link } from "react-router-dom";
import "../styles/estilos/prendas.css";
import signoAtencion from "../images/signoatencion.png";
import dashboardStyle from "../styles/Dashboard.module.css";
import { getItems, saveItems, getPaymentInformation, getAllCategories } from "../services/api";
import Swal from "sweetalert2";
import logoPng from "../images/Frame.png";

const Modal1 = ({
  onNextClick,
  closeModal,
  setPaymentMethod,
  vengodelModal1,
  paymentMethod,
  vengodelModalPagos,
}) => {
  const navigate = useNavigate();
  const { contextData, checkCustomerAlive } = useDataContext();
  const [items, setItems] = useState([]);
  const [selectedQuantities, setSelectedQuantities] = useState({});
  const [selectedItems, setSelectedItems] = useState({});
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);

  // El modal de selección se abre cuando el flujo lo pide (no auto-redirige). El modo
  // del tutor (comprar vs. solo seguimiento) se decide en el inicio; acá solo mostramos.
  useEffect(() => {
    setShowModal(true);
  }, [contextData.customer.id]);

  useEffect(() => {
    if (!contextData || !contextData.customer || !contextData.customer.id) {
      return;
    }
    vengodelModal1(true);
    localStorage.setItem("vengoDelModal1", "true");
    getPaymentInformation(contextData.customer.id, contextData.customer.order_id)
      .then((data) => {
        setPaymentMethod(data.payment_method);
      })
      .catch((error) => {
        console.error("Error al obtener la información de pago:", error);
      });
  }, [contextData.customer.id, contextData.customer.order_id]);

  useEffect(() => {
    if (
      !contextData ||
      !contextData.customer ||
      !contextData.customer.lead_id
    ) {
      return;
    }

    const fetchItems = async () => {
      try {
        const isAlive = await checkCustomerAlive(contextData.customer.id);
        if (!isAlive) {
          Swal.fire({
            icon: "warning",
            iconColor: "#d54ab7",
            confirmButtonColor: "#0071ce",
            title: "Atencion",
            text: "Tu cuenta ha sido desactivada. Por favor, contacta con tu representante para más información.",
          }).then( () => {
            navigate("/");
          });
          return;
        }
        const data = await getItems(contextData.customer.order_id);
        const eligibleItems = (Array.isArray(data.result) ? data.result : []).filter(
          (item) => item.size_approved !== true
        );

        if (eligibleItems.length === 0) {
          setItems([]);
          setSelectedItems({});
          setLoading(false);
          setShowModal(false);
          return;
        }

        // Precargamos la selección ACTUAL del cliente (order_item_id → cantidad) para
        // que al modificar arranque con lo que ya tiene elegido y no de cero.
        const selMap = {};
        try {
          const cats = await getAllCategories(
            contextData.customer.id,
            contextData.customer.order_id
          );
          (Array.isArray(cats) ? cats : []).forEach((c) => {
            selMap[c.order_item_id] = Number(c.quantity) || 0;
          });
        } catch (e) {
          console.warn("No se pudo precargar la selección actual:", e?.message);
        }

        const initialSelectedItems = {};
        const initialQuantities = {};
        eligibleItems.forEach((item, index) => {
          const actual = selMap[item.id] || 0;
          if (item.name === "Bandera") {
            initialSelectedItems[index] = true;
            initialQuantities[index] = "1";
          } else if (actual > 0) {
            initialSelectedItems[index] = true;
            initialQuantities[index] = String(actual); // sin tope (grupos pueden ser 100+)
          } else {
            initialSelectedItems[index] = false;
            initialQuantities[index] = "0";
          }
        });
        setSelectedItems(initialSelectedItems);
        setSelectedQuantities(initialQuantities);
        setItems(eligibleItems);
        setLoading(false);
      } catch (error) {
        console.log(`Error en la solicitud de items: ${error.message}`);
      }
    };

    fetchItems();
  }, [contextData.customer.order_id]);

  const handleQuantityChange = (index, event) => {
    const newQuantities = { ...selectedQuantities };
    newQuantities[index] = event.target.value;
    setSelectedQuantities(newQuantities);
  };

  const handleCheckboxChange = (index) => {
    const newSelectedItems = { ...selectedItems };
    newSelectedItems[index] = !newSelectedItems[index];
    setSelectedItems(newSelectedItems);
  };

  // Un solo control por artículo: "Este no lo quiero" (no seleccionado) o 1–5 unidades.
  const handleItemChoice = (index, value) => {
    const wants = value !== "0" && value !== "";
    setSelectedItems((prev) => ({ ...prev, [index]: wants }));
    setSelectedQuantities((prev) => ({ ...prev, [index]: wants ? value : "0" }));
  };

  // Tutor (3) y delegado (2) manejan la compra del CURSO entero (grupal centralizado):
  // piden la cantidad TOTAL por artículo → entrada libre, sin tope de 5. El normal (1)
  // compra lo suyo con el desplegable acotado.
  const isRepresentative = [2, 3].includes(
    Number(contextData.customer.customer_type)
  );

  const handleSubmit = async (event) => {
    event.preventDefault();

    const selectedItemsToSend = Object.keys(selectedQuantities)
      .filter((index) => selectedItems[index])
      .map((index) => ({
        customer_id: contextData.customer.id,
        order_item_id: items[index].id,
        quantity: parseInt(selectedQuantities[index], 10) || 0,
      }));

    console.log("selectedItemsToSend:", selectedItemsToSend);

    const noItemsSelected = selectedItemsToSend.length === 0;

    const zeroQuantitySelected = selectedItemsToSend.some(
      (item) => item.quantity === 0
    );

    const visibleItems = items.filter((item) => item.name !== "Bandera");

    const noVisibleItemsSelected = selectedItemsToSend.every(
      (item) =>
        !visibleItems.some(
          (visibleItem) => visibleItem.id === item.order_item_id
        )
    );

    if (selectedItemsToSend.length === 0 || noVisibleItemsSelected) {
      Swal.fire({
        icon: "warning",
        iconColor: "#d54ab7",
        confirmButtonColor: "#0071ce",
        title: "Atencion",
        text: "Por favor selecciona la prenda y la cantidad que deseas de ella.",
      });
    } else if (zeroQuantitySelected) {
      Swal.fire({
        icon: signoAtencion,
        iconColor: "#d54ab7",
        confirmButtonColor: "#0071ce",
        title: "Atencion",
        text: "Por favor selecciona la cantidad que vas a querer en la prenda seleccionada.",
      });
    } else if (noItemsSelected) {
      Swal.fire({
        icon: "warning",
        iconColor: "#d54ab7",
        confirmButtonColor: "#0071ce",
        title: "Atencion",
        text: "Por favor selecciona una prenda y especificanos la cantidad que necesitas.",
      });
    } else {
      if (paymentMethod) {
        // Si hay un método de pago, mostrar la alerta para volver a seleccionarlo
        Swal.fire({
          icon: "warning",
          iconColor: "#d54ab7",
          text: "Deberas seleccionar nuevamente el metodo de pago",
          confirmButtonColor: "#0071ce",
          showCancelButton: true,
          cancelButtonColor: "#d54ab7",
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
        }).then(async (result) => {
          if (result.isConfirmed) {
            try {
              await saveItems(
                contextData.customer.id,
                selectedItemsToSend
              );
            } catch (error) {
              console.error(`Error al guardar items: ${error.message}`);
              if (error?.status === 409 || String(error.message).includes("409")) {
                Swal.fire({
                  icon: "warning",
                  iconColor: "#d54ab7",
                  confirmButtonColor: "#0071ce",
                  title: "Atención",
                  // El backend dice POR QUÉ está cerrada (pago, producción o talles
                  // aprobados). Antes se mostraba siempre "talles aprobados", que casi
                  // nunca era el motivo real.
                  text:
                    error?.serverMessage ||
                    "No se pueden modificar prendas con talles aprobados.",
                });
                return;
              }
              Swal.fire({
                icon: "error",
                iconColor: "#d54ab7",
                confirmButtonColor: "#0071ce",
                title: "Error",
                text: "Por favor, inténtelo de nuevo más tarde.",
              });
            }
            onNextClick();
          }
        });
      } else {
        // Si no hay método de pago, continuar sin mostrar alerta
        try {
          await saveItems(
            contextData.customer.id,
            selectedItemsToSend
          );
        } catch (error) {
          console.error(`Error al guardar items: ${error.message}`);
          if (error?.status === 409 || String(error.message).includes("409")) {
            Swal.fire({
              icon: "warning",
              iconColor: "#d54ab7",
              confirmButtonColor: "#0071ce",
              title: "Atención",
              text:
                error?.serverMessage ||
                "No se pueden modificar prendas con talles aprobados.",
            });
            return;
          }
          Swal.fire({
            icon: "error",
            iconColor: "#d54ab7",
            confirmButtonColor: "#0071ce",
            title: "Error",
            text: "Por favor, inténtelo de nuevo más tarde.",
          });
        }
        onNextClick();
      }
    }
  };

  return (
    <>
      {loading ? ( // Mostrar indicador de carga mientras se verifica
        <div className="contcargando">
          <img src={logoPng} alt="littleBlueLogo" className="imgcargando" />
          <h2 className="text-muted">CARGANDO...</h2>
          <div className="loader"></div>
        </div>
      ) : (
        <>
          {showModal && contextData.customer.order_type !== 2 && (
            <div className={dashboardStyle.modalBackground}>
              <div className={dashboardStyle.modal}>
                <form onSubmit={handleSubmit}>
                  <div className={dashboardStyle.modalHeader}>
                    <span className={dashboardStyle.modalStep}>Paso 1 de 2</span>
                    <h2 className={dashboardStyle.modalTitle}>
                      ¿Qué querés{" "}
                      <span className={dashboardStyle.modalTitleAccent}>comprar</span>?
                    </h2>
                    <p className={dashboardStyle.modalSubtitle}>
                      Elegí cuántas unidades querés de cada artículo (hasta 5). Lo que no quieras, dejá «Este no lo quiero».
                    </p>
                  </div>

                  <div className={dashboardStyle.modalItemList}>
                    {Array.isArray(items) &&
                      items.map((item, index) => {
                        const shouldHide = [
                          "Rifas (10 x pax)",
                          "Producto personalizado",
                        ].includes(item.name);

                        if (shouldHide || item.name === "Bandera") {
                          return null;
                        }

                        return (
                          <div
                            key={index}
                            className={dashboardStyle.modalItemRow}
                          >
                            <div className={dashboardStyle.modalItemInfo}>
                              <span className={dashboardStyle.modalItemName}>
                                {item.name}
                              </span>
                              {item.alias ? (
                                <span className={dashboardStyle.modalItemAlias}>
                                  {item.alias}
                                </span>
                              ) : null}
                            </div>
                            {isRepresentative ? (
                              <input
                                type="number"
                                min="0"
                                step="1"
                                inputMode="numeric"
                                value={
                                  selectedItems[index]
                                    ? selectedQuantities[index] || "0"
                                    : "0"
                                }
                                onChange={(event) =>
                                  handleItemChoice(index, event.target.value)
                                }
                                className={dashboardStyle.modalQtySelect}
                                aria-label={`Cantidad de ${item.name}`}
                                placeholder="0"
                              />
                            ) : (
                              <select
                                value={selectedItems[index] ? (selectedQuantities[index] || "1") : "0"}
                                onChange={(event) =>
                                  handleItemChoice(index, event.target.value)
                                }
                                className={dashboardStyle.modalQtySelect}
                                aria-label={`Cantidad de ${item.name}`}
                              >
                                <option value="0">Este no lo quiero</option>
                                <option value="1">1 unidad</option>
                                <option value="2">2 unidades</option>
                                <option value="3">3 unidades</option>
                                <option value="4">4 unidades</option>
                                <option value="5">5 unidades</option>
                              </select>
                            )}
                          </div>
                        );
                      })}
                  </div>

                  <div className={dashboardStyle.modalFooter}>
                    {paymentMethod ? (
                      <button
                        type="button"
                        className={dashboardStyle.btnOutline}
                        onClick={closeModal}
                      >
                        Cerrar
                      </button>
                    ) : null}
                    {contextData.customer.customer_type === 3 && !paymentMethod ? (
                      <Link
                        to="/mcb/accountsSummary"
                        className={dashboardStyle.btnOutline}
                      >
                        Cerrar
                      </Link>
                    ) : null}
                    <button
                      type="submit"
                      className={dashboardStyle.btnPrimary}
                    >
                      Siguiente
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default Modal1;
